import Layout from '../../components/feature/Layout';
import Contact from '../home/components/Contact';
import SEO from '../../components/feature/SEO';

const contactoJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contacto - SafeLine Solutions',
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/contacto`,
  description: 'Contáctanos para recibir asesoría HSE personalizada. SafeLine Solutions está aquí para ayudarte a fortalecer la seguridad de tu empresa en Latinoamérica.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Contacto', item: `${import.meta.env.VITE_SITE_URL ?? ''}/contacto` },
    ],
  },
};

export default function ContactoPage() {
  return (
    <Layout>
      <SEO
        title="Contacto | SafeLine Solutions - Consultoría HSE"
        description="Contáctanos para recibir asesoría HSE personalizada. SafeLine Solutions está aquí para ayudarte a fortalecer la seguridad de tu empresa en Latinoamérica."
        keywords="contacto SafeLine Solutions, asesoría HSE, cotizar consultoría seguridad"
        canonical="/contacto"
        jsonLd={contactoJsonLd}
      />
      <div className="pt-20">
        <Contact />
      </div>
    </Layout>
  );
}
